export default {"src":"/_next/static/media/integrated_advanced_analytics.e522fde6.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};